<template>
  <b-navbar fixed="bottom" variant="light" class="border-top border-secondary">
    <div class="ml-auto">
      <social-networks />
    </div>
  </b-navbar>
</template>

<script>
  import SocialNetworks from '@/components/social-networks';

  export default {
    name: 'FooterComponent',
    components: {
      SocialNetworks,
    },
  };
</script>

<style lang="scss" scoped>
  @import '~@/scss/vars';
</style>
